var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    { staticStyle: { overflow: "hidden" }, attrs: { width: "256" } },
    [
      _c(
        "v-card",
        { staticStyle: { "background-color": "#F5F5F5" }, attrs: { flat: "" } },
        [
          _c(
            "v-card-title",
            { staticClass: "pb-0" },
            [
              _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                _c("span", { staticClass: "orange--text text-uppercase" }, [
                  _vm._v(_vm._s(_vm.nameGame)),
                ]),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.nameConfig) + " "),
              ]),
              _c("v-spacer"),
              _c(
                "v-menu",
                {
                  attrs: { bottom: "", left: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "white--text",
                                  attrs: {
                                    elevation: "0",
                                    width: "100%",
                                    color: "blue",
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _vm._v(" Utils "),
                              _c(
                                "v-icon",
                                { staticClass: "ml-2", attrs: { dense: "" } },
                                [_vm._v("mdi-menu-down")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0", attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        { on: { click: _vm.onValidate } },
                        [_c("v-list-item-title", [_vm._v("Validate")])],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { on: { click: _vm.onMakePackage } },
                        [_c("v-list-item-title", [_vm._v("Create Package")])],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        { on: { click: _vm.onBuildPatchConfigV1 } },
                        [
                          _c("v-list-item-title", [
                            _vm._v("Build Patch Config V1"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { on: { click: _vm.onBuildPatchConfigV2 } },
                        [
                          _c("v-list-item-title", [
                            _vm._v("Build Patch Config V2"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { on: { click: _vm.onSavePatchConfig } },
                        [
                          _c("v-list-item-title", [
                            _vm._v("Save Patch Config"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { on: { click: _vm.onResetPatchConfig } },
                        [
                          _c("v-list-item-title", [
                            _vm._v("Reset Patch Config"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        { on: { click: _vm.onPatchProducts } },
                        [_c("v-list-item-title", [_vm._v("Patch Products")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "mt-0" },
            [
              _c("r-global-config-view"),
              !_vm.isSharedConfig ? _c("r-shared-config-view") : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-list",
        {
          staticClass: "drag__holder py-0",
          attrs: { dense: "", "background-color": "blue" },
        },
        [
          _c(
            "v-list-item",
            { staticClass: "px-3" },
            [
              _c("v-checkbox", {
                staticClass: "drag__cb ma-0 pa-0",
                attrs: { label: "Reorder menu", "hide-details": "", dense: "" },
                model: {
                  value: _vm.dndEnabled,
                  callback: function ($$v) {
                    _vm.dndEnabled = $$v
                  },
                  expression: "dndEnabled",
                },
              }),
              _c("v-spacer"),
              !_vm.isSavedOrder
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          small: "",
                                          icon: "",
                                          color: "success",
                                        },
                                        on: { click: _vm.saveOrder },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("mdi-check-circle"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3678746020
                      ),
                    },
                    [_c("span", [_vm._v("Save order")])]
                  )
                : _vm._e(),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    small: "",
                                    icon: "",
                                    disabled: _vm.isDefaultOrder,
                                  },
                                  on: { click: _vm.onResetClick },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-restore"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Reset to default")])]
              ),
            ],
            1
          ),
          _vm.dndEnabled
            ? _c(
                "v-list-item",
                { staticClass: "px-3 mt-n4", attrs: { dense: "" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "caption",
                      staticStyle: {
                        "font-size": "9px !important",
                        "padding-left": "4px",
                      },
                    },
                    [
                      _c("b", { staticStyle: { "user-select": "none" } }, [
                        _vm._v("Your ID:"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.getMyUID()) + " "),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-list",
        { staticClass: "mb-6", attrs: { dense: "" } },
        [
          _c(
            "draggable",
            {
              attrs: {
                "item-key": "name",
                disabled: !_vm.dndEnabled,
                animation: "150",
                handle: ".drag-handle",
                "ghost-class": "drag-ghost",
                tag: "div",
              },
              model: {
                value: _vm.dItems,
                callback: function ($$v) {
                  _vm.dItems = $$v
                },
                expression: "dItems",
              },
            },
            _vm._l(_vm.dItems, function (el) {
              return _c(
                "v-list-item",
                {
                  key: el.name,
                  attrs: {
                    href: el.href,
                    target: el.target,
                    to: !el.href ? { name: el.name } : null,
                    color: "light-blue darken-3",
                  },
                },
                [
                  _c(
                    "v-list-item-icon",
                    { staticStyle: { "margin-right": "16px" } },
                    [_c("v-icon", [_vm._v(_vm._s(el.icon))])],
                    1
                  ),
                  _c("v-list-item-title", [_vm._v(_vm._s(el.title))]),
                  _c("v-spacer"),
                  _vm.dndEnabled
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "drag-handle",
                          attrs: {
                            icon: "",
                            small: "",
                            color: "black",
                            title: "Drag to reorder",
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-drag"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("r-package-dialog", { ref: "r-package-export" }),
      _c("r-patch-builder-dialog-v1", { ref: "patch-builder-dialog-v1" }),
      _c("r-patch-builder-dialog-v2", { ref: "patch-builder-dialog-v2" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }